import apiClient from "../../services/apiClient";

export async function createStudentAPI(data) {
  const response = await apiClient.post("/api/v1/student/create", data, {
    withAuth: true,
  });
  return response.data;
}

export async function createBulkStudentAPI(data) {
  const response = await apiClient.post("/api/v1/student/create/bulk", data, {
    withAuth: true,
  });
  return response.data;
}

export async function createLevelAPI(data) {
  const response = await apiClient.post("/api/v1/level/create", data, {
    withAuth: true,
  });
  return response.data;
}

export async function fetchLevelListAPI(user_id = undefined) {
  let url = `/api/v1/level/list`;
  if (user_id) {
    url += `?user_id=${user_id}`;
  }
  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function fetchStudentsAPI(user_id = undefined) {
  let url = `/api/v1/student/list`;
  if (user_id) {
    url += `?user_id=${user_id}`;
  }
  const response = await apiClient.get(url, { withAuth: true });
  return response.data;
}

export async function updateLevelAPI(data, id) {
  const response = await apiClient.put(`/api/v1/level?id=${id}`, data, {
    withAuth: true,
  });
  return response.data;
}

export async function updateStudentAPI(data, id) {
  const response = await apiClient.put(`/api/v1/student?id=${id}`, data, {
    withAuth: true,
  });
  return response.data;
}

export async function deleteStudentAPI(id) {
  const response = await apiClient.delete(`/api/v1/student?id=${id}`, {
    withAuth: true,
  });
  return response.data;
}

export async function deleteLevelAPI(id) {
  const response = await apiClient.delete(`/api/v1/level?id=${id}`, {
    withAuth: true,
  });
  return response.data;
}

export async function createStudentLevelAPI(studentId, levelId) {
  const response = await apiClient.post(
    "/api/v1/student/level",
    { student_id: studentId, level_id: levelId },
    { withAuth: true }
  );
  return response.data;
}

export async function deleteStudentLevelAPI(studentId, levelId) {
  const response = await apiClient.delete(
    `/api/v1/student/level?student_id=${studentId}&level_id=${levelId}`,
    { withAuth: true }
  );
  return response.data;
}

export async function bulkIncreaseStudentGradeAPI() {
  const response = await apiClient.post(
    "/api/v1/student/grade/bulk-increase",
    {},
    { withAuth: true }
  );
  return response.data;
}
